import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import Email from 'src/app/components/Email/Email';
import {
  resetEmailChange,
  resetEmailFocus,
  resetEmailBlur,
  resetEmailSetValidationMessage,
  resetEmailSetVisualization,
  resetEmailSet
} from 'src/app/redux/actions/reset/resetEmail';
import { resetEmailSend } from 'src/app/redux/actions/reset/resetEmailSend';
import emailPropTypes from 'src/app/propTypes/email';
import 'src/app/containers/Reset/ResetEmailFormContainer.scss';


class ResetEmailFormContainer extends React.Component {

  inputRef = React.createRef();

  applySuggestedDomain = (email) => {
    const { dispatch } = this.props;
    dispatch(resetEmailSet(email));
  };

  onBlur = ({ target }) => {
    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = target;

    dispatch(resetEmailBlur(markedAsWrong, validationMessage));
    dispatch(resetEmailSetValidationMessage(validationMessage));
  };

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { value, validationMessage } = target;

    dispatch(resetEmailChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(resetEmailFocus());
  };

  onSubmit = (event) => {
    event.preventDefault();

    const { dispatch, value } = this.props;
    const { current } = this.inputRef;
    const form = event.target;

    if (!form.checkValidity()) {
      dispatch(resetEmailSetValidationMessage(current.validationMessage));
      dispatch(resetEmailSetVisualization(true));
      return;
    }

    dispatch((resetEmailSend(value)));
  };

  render() {
    const { value, validationMessage, markedAsWrong, apiError, focus, sending } = this.props;
    const { onBlur, onFocus, onChange, onSubmit, applySuggestedDomain, inputRef } = this;

    return (
      <form styleName="reset-form" onSubmit={ onSubmit } noValidate>

        <div styleName="reset-form__title title">
          <h4 styleName="title__primary">Przypomnij hasło</h4>
          <p styleName="title__secondary">Podaj nam swój e-mail.</p>
          <p styleName="title__secondary">Wyślemy Ci link do zmiany hasła.</p>
        </div>

        <Email
          disabled={ sending }
          {
            ...{
              value,
              validationMessage,
              markedAsWrong,
              focus,
              apiError,
              inputRef,
              onChange,
              onFocus,
              onBlur
            }
          }
          onPickedEmail={ applySuggestedDomain }
          dataTest="input-forgot-password-email"
        />

        <button styleName="reset-form__send"
                type="submit"
                data-test="button-forgot-password"
                disabled={ sending }
        >
          Wyślij
        </button>
      </form>
    );
  }
}

ResetEmailFormContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  ...emailPropTypes
};

const mapStateToProps = state => ({
  ...state.resetEmailReducer,
  sending: state.resetEmailSendReducer.sending
});

export default connect(mapStateToProps)(ResetEmailFormContainer);
